/** 64-char hex string from APNs device token — not valid for token_lut (FCM required). */
export function isApnsToken(token: string): boolean {
  return /^[A-Fa-f0-9]{64}$/.test(token);
}

/** FCM tokens are long opaque strings; reject APNs-shaped values before posting to token_lut. */
export function isValidFcmToken(token: string): boolean {
  return !!token && token.length > 80 && !isApnsToken(token);
}
